<script>
import financeMixin from '@mixins/financeMixin'
import dayjs from '@services/date/index'
const _ = require('lodash')

export default {
  mixins: [financeMixin],
  props: {
    invoiceDetailData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      filterMode: 'staff', // staff or day,
      headers: [],
      invoiceDetails: [],
    }
  },
  computed: {
    tableHeaders() {
      if (this.filterMode === 'staff') {
        return [
          {
            text: this.$t('finance.invoiceViewDetailTblHeaderDate'),
            value: 'date',
            width: '10%',
          },
          {
            text: this.$t('finance.invoiceViewDetailTblHeaderStartFinish'),
            value: 'placement_duration',
            width: '10%',
          },
          {
            text: this.$t('finance.invoiceViewDetailTblHeaderType'),
            value: 'type',
            width: '50%',
          },
          {
            text: this.$t('finance.invoiceViewDetailTblHeaderQty'),
            value: 'clientHours',
            align: 'right',
            width: '5%',
          },
          {
            text: this.$t('finance.invoiceViewDetailTblHeaderRate'),
            value: 'clientRate',
            align: 'right',
            width: '10%',
          },
          {
            text: this.$t('finance.invoiceViewDetailTblHeaderTotalExTax'),
            value: 'exGST',
            align: 'right',
            width: '10%',
          },
          {
            text: '',
            value: 'download',
            align: 'right',
            width: '5%',
          },
        ]
      } else {
        return [
          {
            text: this.$t('finance.invoiceViewDetailTblHeaderEmployee'),
            align: 'start',
            value: 'fullname',
            width: '30%',
          },
          {
            text: this.$t('finance.invoiceViewDetailTblHeaderType'),
            value: 'type',
            width: '30%',
          },
          {
            text: this.$t('finance.invoiceViewDetailTblHeaderStartFinish'),
            value: 'placement_duration',
            width: '10%',
          },
          {
            text: this.$t('finance.invoiceViewDetailTblHeaderQty'),
            value: 'clientHours',
            align: 'right',
            width: '5%',
          },
          {
            text: this.$t('finance.invoiceViewDetailTblHeaderRate'),
            value: 'clientRate',
            align: 'right',
            width: '10%',
          },
          {
            text: this.$t('finance.invoiceViewDetailTblHeaderTotalExTax'),
            value: 'exGST',
            align: 'right',
            width: '10%',
          },
          {
            text: '',
            value: 'download',
            align: 'right',
            width: '5%',
          },
        ]
      }
    },
  },
  mounted() {
    this.groupInvoiceData(this.filterMode)
  },
  methods: {
    changeInvoiceMode() {
      this.groupInvoiceData(this.filterMode)
    },
    groupInvoiceData(mode) {
      // reset local data used to display groups
      this.invoiceDetails = []
      var invoiceLinks = this.invoiceDetailData.items

      if (mode === 'staff') {
        // add group filter
        invoiceLinks.forEach((element, index) => {
          element.items.forEach((element2, index2) => {
            element2.groupFilter = element2.firstName + ' ' + element2.lastName
          })
        })

        // group items
        invoiceLinks.forEach((element, index) => {
          var subTotalPerGroup = 0
          var result = _(element.items)
            .groupBy((x) => x.groupFilter)
            .map((value, key) => ({
              groupFilter: key,
              shorttermInvoice: value,
            }))
            .value()

          // calc total
          element.items.forEach((element2, index2) => {
            subTotalPerGroup += element2.clientRate * element2.clientHours
          })

          // push to array for display
          this.invoiceDetails.push({
            location: element.locationName,
            sortPlacements: result,
            totalExTax: subTotalPerGroup,
            itemNo: element.items.length,
          })
        })
      } else if (mode === 'day') {
        // add group filter
        invoiceLinks.forEach((element, index) => {
          element.items.forEach((element2, index2) => {
            element2.groupFilter = dayjs(element2.startTimeUTC)
              .tz(this.invoiceDetailData.locationTimeZone, false)
              .format('ddd MMM D, YYYY')
          })
        })

        // group items
        invoiceLinks.forEach((element, index) => {
          var subTotalPerGroup = 0
          var result = _(element.items)
            .groupBy((x) => x.groupFilter)
            .map((value, key) => ({
              groupFilter: key,
              shorttermInvoice: value,
            }))
            .value()

          // calc total
          element.items.forEach((element2, index2) => {
            subTotalPerGroup += element2.clientRate * element2.clientHours
          })

          // push to array for display
          this.invoiceDetails.push({
            location: element.locationName,
            sortPlacements: result,
            totalExTax: subTotalPerGroup,
            itemNo: element.items.length,
          })
        })
      }
    },
    downloadTimesheet(item) {
      this.$emit('downloadTimesheet', {
        timesheetRecordId: item.timesheetRecordID,
      })
    },
    disableDownloadButton(item) {
      return item.timesheetFileID <= 0
    },
    compTooltipText(item) {
      const tooltipKey = this.disableDownloadButton(item)
        ? 'finance.timesheetFileNotAvailableText'
        : 'finance.timesheetDownloadButtonTip'
      return this.$t(tooltipKey)
    },
  },
}
</script>

<template>
  <v-col>
    <v-btn-toggle
      v-model="filterMode"
      class="mb-4"
      group
      color="info"
      @change="changeInvoiceMode"
    >
      <v-btn value="staff">
        {{ $t('finance.invoiceViewDetailStaffGroup') }}
      </v-btn>

      <v-btn value="day">
        {{ $t('finance.invoiceViewDetailDayGroup') }}
      </v-btn>
    </v-btn-toggle>

    <div
      v-for="(parentItem, index) in invoiceDetails"
      :key="`invoice-view-parent-array_${index}`"
      class="mb-4"
    >
      <h2 class="mb-2">{{ parentItem.location }}</h2>

      <div
        v-for="(item2, index2) in parentItem.sortPlacements"
        :key="`invoice-view-sortPlacements_${index2}`"
      >
        <div class="mb-1 invoice-group-filter">{{ item2.groupFilter }}</div>

        <template v-if="invoiceDetails.length > 0">
          <v-data-table
            :headers="tableHeaders"
            :items="item2.shorttermInvoice"
            class="cl-elevation rounded-xl mb-6"
            hide-default-footer
            disable-sort
          >
            <template v-slot:[`header.exGST`]="{ header }">
              {{ header.text + displayGSTtext() }}
            </template>

            <template v-slot:[`item.fullname`]="{ item }">
              {{ item.firstName }} {{ item.lastName }}
            </template>

            <template v-slot:[`item.date`]="{ item }">
              {{
                displayDate({
                  date: item.startTimeUTC,
                  countryTimezone: invoiceDetailData.locationTimeZone,
                })
              }}
            </template>

            <template v-slot:[`item.placement_duration`]="{ item }">
              {{
                displayHour({
                  date: item.startTimeUTC,
                  countryTimezone: invoiceDetailData.locationTimeZone,
                })
              }}
              -
              {{
                displayHour({
                  date: item.endTimeUTC,
                  countryTimezone: invoiceDetailData.locationTimeZone,
                })
              }}
            </template>

            <template v-slot:[`item.exGST`]="{ item }">
              {{ countdisplayPlacementRate(item) }}
            </template>

            <template v-slot:[`item.download`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <v-btn
                      class="invoice-line-item__download-timesheet-btn"
                      color="primary"
                      small
                      text
                      :disabled="disableDownloadButton(item)"
                      @click="downloadTimesheet(item)"
                    >
                      <v-icon>
                        mdi-cloud-download
                      </v-icon>
                    </v-btn>
                  </span>
                </template>
                <span>
                  {{ compTooltipText(item) }}
                </span>
              </v-tooltip>
            </template>
          </v-data-table>
        </template>
      </div>
    </div>
  </v-col>
</template>
